import api from './index';
import { CreateOfferedReportDTO, OfferedReport } from '@callmart/types';

const BASE = '/offeredReport';

export const getLatestOfferedReports = async (params: {
    dateFrom?: string;
    dateTo?: string;
    offeredCluster: number;
}) => {
    return api.get<OfferedReport[]>(`${BASE}/latest`, { params }).then((res) => res.data);
};

export const createOneOfferedReport = async (data: CreateOfferedReportDTO) => {
    // returns null if the report deleted
    return api.post<OfferedReport | null>(`${BASE}/one`, data).then((res) => res.data);
};

export const createOfferedReports = async (data: CreateOfferedReportDTO[]) => {
    return api.post<{ created: number; deleted: number; skipped: number }>(`${BASE}`, data).then((res) => res.data);
};

export const getOfferedReportSummary = async ({
    dateFrom,
    dateTo,
    includeHistory = false,
}: {
    dateFrom?: string;
    dateTo?: string;
    includeHistory?: boolean;
}) => {
    return api
        .get(`${BASE}/summary`, {
            params: { dateFrom, dateTo, includeHistory },
        })
        .then((res) => res.data);
};

export const getOfferedReportExportData = async ({ dateFrom, dateTo }: { dateFrom?: string; dateTo?: string }) => {
    return api
        .get(`${BASE}/export`, {
            params: { dateFrom, dateTo },
        })
        .then((res) => res.data);
};

export const getLatestOfferedReportDate = async ({
    dateFrom,
    dateTo,
    workingUnitLocationId,
}: {
    dateFrom: string;
    dateTo: string;
    workingUnitLocationId: number;
}) => {
    return api
        .get(`${BASE}/latest-date`, {
            params: { dateFrom, dateTo, workingUnitLocationId },
        })
        .then((res) => res.data);
};
